namespace GeniuzPOS.Purchase {
    export interface ReportDailyCNForm {
        SysDocNo: Serenity.StringEditor;
        CreditNoteNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        SupplierId: Serenity.StringEditor;
        SupplName: Serenity.StringEditor;
        RefDocNo1: Serenity.StringEditor;
        PayTermCode: Serenity.StringEditor;
        DueDate: Serenity.DateEditor;
        WhsId: Serenity.StringEditor;
        TotalAmt: Serenity.DecimalEditor;
        DiscAmt: Serenity.DecimalEditor;
        NetAmt: Serenity.DecimalEditor;
        VatAmt: Serenity.DecimalEditor;
        ExciseTaxAmt: Serenity.DecimalEditor;
        CreditNoteAmt: Serenity.DecimalEditor;
        DepositAmt: Serenity.DecimalEditor;
    }

    export class ReportDailyCNForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.ReportDailyCN';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportDailyCNForm.init)  {
                ReportDailyCNForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(ReportDailyCNForm, [
                    'SysDocNo', w0,
                    'CreditNoteNo', w0,
                    'DocDate', w1,
                    'SupplierId', w0,
                    'SupplName', w0,
                    'RefDocNo1', w0,
                    'PayTermCode', w0,
                    'DueDate', w1,
                    'WhsId', w0,
                    'TotalAmt', w2,
                    'DiscAmt', w2,
                    'NetAmt', w2,
                    'VatAmt', w2,
                    'ExciseTaxAmt', w2,
                    'CreditNoteAmt', w2,
                    'DepositAmt', w2
                ]);
            }
        }
    }
}
